import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { helpLinksReducer } from '../reducers/helpLinks';
import { experimentsReducer } from '../reducers/experiments';
import { referenceLinkReducer } from '../reducers/referenceLink';
import { formLayoutModalReducer } from '../reducers/formLayoutModal';
import { moderationIssuesReducer } from '../reducers/moderationIssues';
import { sendFeedbackReducer } from '../reducers/sendFeedback';
import { formKeyReducer } from '../reducers/formKey';
import { formInitialStateReducer } from '../reducers/formInitialState';
var composeEnhancers = function () {
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    var _window = window,
      __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ = _window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: "feedback-form-widget: ".concat(document.title)
      });
    }
  }
  return compose;
}();
export function createReduxStore(options) {
  var reducer = combineReducers({
    helpLinks: helpLinksReducer,
    experiments: experimentsReducer,
    referenceLink: referenceLinkReducer,
    formLayoutModal: formLayoutModalReducer,
    moderationIssues: moderationIssuesReducer,
    sendFeedback: sendFeedbackReducer,
    formKey: formKeyReducer,
    formInitialState: formInitialStateReducer
  });
  var context = options.context;
  var enhancers = composeEnhancers(applyMiddleware(thunkMiddleware.withExtraArgument(context)));
  if (options.initialState) {
    return createStore(reducer, options.initialState, enhancers);
  } else {
    return createStore(reducer, enhancers);
  }
}